import { developerCompFrenchData } from "./developer.data";
import { graphicDesignerCompFrenchData } from "./graphic-designer.data";
import { developerCompEnglishData } from "./developer.data";
import { graphicDesignerCompEnglishData } from "./graphic-designer.data";

export const SKILL_MAIN_COMP_DATA = {
  en: [developerCompEnglishData, graphicDesignerCompEnglishData],
  fr: [developerCompFrenchData, graphicDesignerCompFrenchData],
};
